<template>
  <div :class="['input-container', {focused: isLabelCollapsed}]">
    <input
      v-on="$listeners"
      v-model="__modelValue"
      :id="inputId"
      :class="['mobile', {has_error: invalid}]"
      :name="inputName"
      pattern="^\+[1-9]\d{1,14}$"
      type="tel"
      inputmode="tel"
      @focus="handleInputFocus"
      @blur="handleInputBlur"
    />

    <label :for="inputId" class="placeholder-label">{{ label }}</label>
  </div>
</template>

<script>
export default {
  name: 'BasePhoneNumberFormInput',
  emits: ['update:modelValue'],
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: {
      type: [String, Number],
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    inputId: {
      type: String,
      default: 'inputMsisdn'
    },
    inputName: {
      type: String,
      default: 'mobile'
    },
    invalid: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isInputFocused: false
    }
  },
  computed: {
    __modelValue: {
      get () {
        return this.modelValue
      },
      set (value) {
        this.$emit('update:modelValue', value)
      }
    },
    isLabelCollapsed () {
      return !!this.__modelValue || this.isInputFocused
    }
  },
  methods: {
    handleInputFocus () {
      this.isInputFocused = true
    },
    handleInputBlur () {
      this.isInputFocused = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/formInput/BasePhoneNumberFormInput.vue